import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../lib/api";
import { trackMetaPageView } from "../lib/metaPixel";

/**
 * On every route change:
 *   - Fire an anonymous page_view for the daily internal digest
 *   - If the URL has a hash (e.g. /guide#conveyancing) — scroll to that element
 *   - Otherwise — scroll the window to the top
 *
 * Uses a tiny rAF + timeout combo so the target element has time to mount
 * before we try to scroll to it.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    trackPageView(pathname);
    trackMetaPageView(pathname);
  }, [pathname]);

  // pathname + hash are the only meaningful deps — other refs are local to the
  // effect body and intentionally re-resolved each run.
  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0, left: 0 });
        }
      };
      requestAnimationFrame(() => setTimeout(tryScroll, 0));
      return;
    }
    window.scrollTo({ top: 0, left: 0 });
  }, [pathname, hash]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default ScrollToTop;
